<template>
  <!-- MENU BOTTOM BAR -->
  <div class="menu-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-3 col-md-1 d-flex align-items-center">
          <div class="hora">
            <ul>
              <li>
                <span>{{ hours + ':' + minutes }}</span>
              </li>
              <li>
                <span>Z {{ zhours + ':' + minutes }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-3 col-md4 text-center d-flex justify-content-center align-items-center">
          <div class="lugar">
            <ul>
              <li>
                <span>{{ globals.predio }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-6 col-md-2 text-end d-flex justify-content-end align-items-center options-footer">
          <div class="altura">
            <h5>{{ useUtils().metersToFeet(elevation, 0) }} ft</h5>
          </div>

          <div class="coordenadas">
            <ul>
              <li>
                <span>S {{ displayCoords[0]?.toFixed(4) }}</span>
              </li>
              <li>
                <span>W {{ displayCoords[1]?.toFixed(4) }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 col-md-5 justify-content-end">
          <div v-if="showLatestMosaic">
            <button class="btn btn-sm" :class="{ 'btn-puzzle-active': viewLatestMosaic }" 
              @click="viewLatestMosaic = !viewLatestMosaic" title="Ver/ocultar último mosaico">
              <i class="bi bi-puzzle unit-icon unit-icon-svg" style="color: white;"></i>
            </button>
          </div>
          <div v-if="showPatrullas">
            <button v-for="unit in filteredPatrullasOnline" :key="unit.unit_id" class="btn btn-sm"
              :class="{ 'btn-active': unit.estado === 1 }" :id="unit.unit_id" name="unit"
              @click="togglePatrullaSelection(unit.unit_id, unit.location)" :title="unit.name">
              <i
                class="bi bi-shield-check unit-icon unit-icon-svg"
                aria-label="Unit Icon"
                :style="{ color: intToHexColor(unit.color) }"
              ></i>
            </button>
          </div>
          <div v-if="showAviones">
            <button v-for="unit in filteredUnitsOnline" :key="unit.unit_id" class="btn btn-sm"
              :class="{ 'btn-active': unit.estado === 1 }" :id="unit.unit_id" name="unit"
               @click="toggleUnitSelection(unit.location)" :title="unit.name"
              @contextmenu.prevent="(e) => openContextMenu(e, unit.unit_id)"
              @auxclick="(e) => openContextMenu(e, unit.unit_id)" @touchstart="(e) => handleTouchStart(e, unit.unit_id)"
              @touchend="(e) => handleTouchEnd(e, unit.unit_id)" @touchmove="handleTouchMove">
              <img alt="Unit Icon" class="unit-icon" :src="'/images/unit_' + unit.unit_id + '.png'" />
            </button>
          </div>
          <div v-if="showBases">
            <button v-for="unit in basesOnline" :key="unit.unit_id" class="btn btn-sm" :id="unit.unit_id" name="base"
              @click="toggleUnitSelection(unit.location)" :title="unit.name" @contextmenu.prevent="">
              <img alt="Unit Icon" class="unit-icon" :src="'/images/unit_' + unit.unit_id + '.png'" />
            </button>
          </div>
          <!-- Menú contextual -->
          <div v-if="isMenuVisible" ref="menuElement" class="dropdown-menu dropdown-menu-small show"
            :style="menuStyle as CSSProperties" @click.stop>
            <a class="dropdown-item" href="#" @click="selectOptionLocal('online', contextUnitId)">
              <i class="bi bi-camera-reels me-2"></i>Video Online
            </a>
            <a class="dropdown-item d-flex justify-content-between align-items-center" href="#"
              @click="selectOptionLocal('seguir', contextUnitId)">
              <span><i class="bi bi-geo me-2"></i>Seguir</span>
              <input type="checkbox" class="form-check-input"
                :checked="contextUnitId ? getCheckboxState(contextUnitId, 'seguir') : false" @click.stop
                @change="(e) => handleSeguirChange(e, contextUnitId)" />
            </a>
            <a class="dropdown-item d-flex justify-content-between align-items-center" href="#"
              @click="selectOptionLocal('missionPlan', contextUnitId)">
              <span><i class="bi bi-journal-text me-2"></i>Plan de Misión</span>
              <input type="checkbox" class="form-check-input"
                :checked="contextUnitId ? getCheckboxState(contextUnitId, 'missionPlan') : false" @click.stop
                @change="(e) => handleMissionPlanCheckboxChange(e, contextUnitId)" />
            </a>
            <a class="dropdown-item d-flex justify-content-between align-items-center" href="#"
              @click="selectOptionLocal('events', contextUnitId)">
              <span><i class="bi bi-bookmark-star me-2"></i>Eventos Misión</span>
              <input type="checkbox" class="form-check-input"
                :checked="contextUnitId ? getCheckboxState(contextUnitId, 'events') : false" @click.stop
                @change="(e) => handleEventsChange(e, contextUnitId)" />
            </a>
            <a class="dropdown-item d-flex justify-content-between align-items-center" href="#"
              @click="selectOptionLocal('showTrack', contextUnitId)">
              <span><i class="bi bi-bezier2 me-2"></i>Mostrar track</span>
              <input type="checkbox" class="form-check-input"
                :checked="contextUnitId ? getCheckboxState(contextUnitId, 'showTrack') : false" @click.stop
                @change="(e) => handleShowTrackChangeLocal(e, contextUnitId)" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN BOTTOM BAR -->
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, computed, watch, ref } from 'vue'
import type { CSSProperties } from 'vue'
import { useGlobalStore } from '@/stores/global'
import { useUtils } from '@/composables/useUtils'
const { intToHexColor } = useUtils()
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../stores/t-auth'
import API from "../services";

// Importar los nuevos composables
import { useBottomBarTime } from '@/composables/useBottomBarTime'
import { useBottomBarUnits } from '@/composables/useBottomBarUnits'
import { useUnitCheckboxStates } from '@/composables/useUnitCheckboxStates'
import { useMissionData } from '@/composables/useMissionData'
import { useGPSTracking } from '@/composables/useGPSTracking'
import { useUnitTracking } from '@/composables/useUnitTracking'
import { useContextMenu } from '@/composables/useContextMenu'
import { useMosaics } from '@/composables/useMosaics'

const emit = defineEmits(['showVideoLive', 'unitSelected'])
const auth = useAuthStore()
const globals = useGlobalStore()
const { coordenadas, elevation, missionEvents, viewCurrentMissionPlan, 
  screenBounds,viewCurrentMissionEvents, isMobile, zoom, viewLatestMosaic } = storeToRefs(globals)
const showPatrullas = ref(false)
const showAviones = ref(false)
const showBases = ref(false)
const showLatestMosaic = ref(false)

// Recibe el centro del mapa como prop (debe pasarse desde App.vue)
const props = defineProps<{ center?: [number, number] }>()

const displayCoords = computed(() => {
  if (isMobile.value && props.center) {
    return props.center
  }
  return coordenadas.value
})

// ========== COMPOSABLES ==========
const { hours, zhours, minutes, updateTime } = useBottomBarTime()
const { filteredUnitsOnline, filteredPatrullasOnline, basesOnline, getMissionByUnitId, unitsOnline } = useBottomBarUnits()
const { getCheckboxState, setCheckboxState } = useUnitCheckboxStates()
const { processMissionPlan, processEvents } = useMissionData()
const { checkGPS } = useGPSTracking()
const {
  handleShowTrackChange,
  checkAndUpdateAllActiveStates
} = useUnitTracking()
const {
  isMenuVisible,
  menuElement,
  contextUnitId,
  menuStyle,
  selectOption,
  openContextMenu,
  handleClickOutside,
  handleKeydown,
  handleTouchStart,
  handleTouchEnd,
  handleTouchMove,
  cleanup
} = useContextMenu()
const { updateMosaics } = useMosaics()

// ========== FUNCIONES DE UI ==========

const selectedPatrullaId = ref<string | null>(null)

const handleShowVideoLive = (unitId: string) => {
  emit('showVideoLive', unitId)
}
const togglePatrullaSelection = async (unitId: string, unitLocation: any) => {
  // Desactivar track de todas las patrullas (rol 15) excepto la nueva seleccionada
  for (const unit of filteredPatrullasOnline.value) {
    if (unit.unit_id !== unitId) {
      setCheckboxState(unit.unit_id, 'showTrack', false)
      await handleShowTrackChange(getMissionByUnitId, setCheckboxState, unit.unit_id, false)
    }
  }
  viewCurrentMissionPlan.value = false
  viewCurrentMissionEvents.value = false

  selectedPatrullaId.value = unitId
  viewCurrentMissionPlan.value = true
  await processMissionPlan(getMissionByUnitId, unitId, true)
  await handleShowTrackChange(getMissionByUnitId, setCheckboxState, unitId, true)

  emit('unitSelected', unitLocation.coordinates)
}
const toggleUnitSelection = (unitLocation: any) => {
  emit('unitSelected', unitLocation.coordinates)
}

// ========== HANDLERS SIMPLIFICADOS ==========

const handleSeguirChange = (e: Event, unitId: string | null) => {
  if (!unitId) return
  const checked = (e.target as HTMLInputElement).checked
  setCheckboxState(unitId, 'seguir', checked)
  console.log(`Seguir ${unitId}: ${checked}`)
}

const handleMissionPlanCheckboxChange = async (e: Event, unitId: string | null) => {
  if (!unitId) return

  const checked = (e.target as HTMLInputElement).checked
  setCheckboxState(unitId, 'missionPlan', checked)

  viewCurrentMissionPlan.value = checked
  await processMissionPlan(getMissionByUnitId, unitId, checked)

  console.log(`Mission Plan ${unitId}: ${checked}`)
}

const handleEventsChange = async (e: Event, unitId: string | null) => {
  if (!unitId) return

  const checked = (e.target as HTMLInputElement).checked
  setCheckboxState(unitId, 'events', checked)

  viewCurrentMissionEvents.value = checked
  const events = await processEvents(getMissionByUnitId, unitId, checked)

  if (events.length > 0) {
    missionEvents.value = events
  }

  console.log(`Events ${unitId}: ${checked}`)
}

const handleShowTrackChangeLocal = async (e: Event, unitId: string | null) => {
  if (!unitId) return
  const checked = (e.target as HTMLInputElement).checked
  setCheckboxState(unitId, 'showTrack', checked)

  await handleShowTrackChange(getMissionByUnitId, setCheckboxState, unitId, checked)
}

// ========== FUNCIÓN DE ACTUALIZACIÓN PRINCIPAL ==========

// Contador para ejecutar funciones de patrulla cada 15 segundos (1 de cada 5 veces)
let updateCounter = 0
// Contador para actualizar mosaicos cada 2 minutos (1 de cada 40 veces)
let mosaicsUpdateCounter = 0

const updateTimeAndStates = async () => {
  updateTime()

  updateCounter++
  mosaicsUpdateCounter++

  // Ejecutar funciones de patrulla cada 5 ciclos (cada 15 segundos)
  // TODO, parametrizar esto
  if (globals.patrulla.reportCoords && updateCounter % 5 === 0) {
    await checkGPS();
  
    const unitId = globals.patrulla.unitId;
    if (unitId) {
      // Plan de Misión
      viewCurrentMissionPlan.value = true;
      await processMissionPlan(getMissionByUnitId, unitId, true);
      // Eventos Misión
      viewCurrentMissionEvents.value = true;
      const events = await processEvents(getMissionByUnitId, unitId, true);
      if (events.length > 0) {
        missionEvents.value = events;
      }
      // Mostrar Track
      await handleShowTrackChange(getMissionByUnitId, setCheckboxState, unitId, true);
    }
  }

  // Actualizar mosaicos cada 5 ciclos (cada 15 segundos)
  if (mosaicsUpdateCounter % 5 === 0 && zoom.value >= 12 && showLatestMosaic.value) {
    await updateMosaics(24, {
      min_lon: screenBounds.value._southWest.lng,
      min_lat: screenBounds.value._southWest.lat,
      max_lon: screenBounds.value._northEast.lng,
      max_lat: screenBounds.value._northEast.lat
    }) // Últimas 24 horas
    mosaicsUpdateCounter = 0 // Reiniciar contador
  }

  await checkAndUpdateAllActiveStates(
    getCheckboxState,
    unitsOnline.value,
    emit,
    filteredUnitsOnline.value,
    (unitId: string, enabled: boolean) => processMissionPlan(getMissionByUnitId, unitId, enabled),
    (unitId: string, enabled: boolean) => processEvents(getMissionByUnitId, unitId, enabled)
  )
}

// ========== FUNCIONES DE UI ==========

const selectOptionLocal = (option: any, unit_id: string | null) => {
  selectOption(option, unit_id, handleShowVideoLive)
}

// ========== LIFECYCLE ==========

const timer = setInterval(updateTimeAndStates, 3000)

onMounted(async () => {
  document.addEventListener('click', handleClickOutside)
  document.addEventListener('keydown', handleKeydown)
  showPatrullas.value = await API.checkPermiso('SHOW_PATRULLAS')
  showAviones.value = await API.checkPermiso('SHOW_AVIONES')
  showBases.value = await API.checkPermiso('SHOW_BASES')
  showLatestMosaic.value = await API.checkPermiso('SHOW_LATEST_MOSAIC')
  updateTimeAndStates()
})

onBeforeUnmount(() => {
  clearInterval(timer)
  cleanup()
  document.removeEventListener('click', handleClickOutside)
  document.removeEventListener('keydown', handleKeydown)
})

// Cuando cambia la unidad de patrulla, ocultar vistas de la unidad anterior
watch(
  () => globals.patrulla.unitId,
  (newUnitId, oldUnitId) => {
    // Ocultar plan de misión y eventos de la unidad anterior
    viewCurrentMissionPlan.value = false
    viewCurrentMissionEvents.value = false

    // Ocultar track de la unidad anterior
    if (oldUnitId) {
      setCheckboxState(oldUnitId, 'showTrack', false)
      handleShowTrackChange(getMissionByUnitId, setCheckboxState, oldUnitId, false)
    }
  }
)

// Actualizar elevación al centro del mapa en móvil, solo si cambia
let lastCenter: [number, number] | undefined
let updatingElevation = false
watch(
  () => props.center,
  async (newCenter) => {
    if (
      isMobile.value &&
      newCenter &&
      newCenter.length === 2 &&
      (!lastCenter || newCenter[0] !== lastCenter[0] || newCenter[1] !== lastCenter[1]) &&
      !updatingElevation
    ) {
      updatingElevation = true
      lastCenter = [...newCenter]
      await globals.setElevation(String(newCenter[0]), String(newCenter[1]))
      updatingElevation = false
    }
  },
  { immediate: true }
)
</script>

<style scoped>
.menu-footer .lugar ul li span {
  color: #ffffff;
  font-size: 16px;
}

.row {
  justify-content: space-between;
}

.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(50, 50, 50, 0.8);
  min-width: 200px;
  background-color: rgba(50, 50, 50, 0.8);
}

.dropdown-item {
  cursor: pointer;
  padding: 0.5rem 1rem;
  transition: background-color 0.2s;
  color: white;
}

.dropdown-item:hover {
  background-color: #e2e2e2;
}

.dropdown-item:active {
  background-color: #6c757d;
  color: white;
}

.dropdown-item.d-flex {
  align-items: center;
}

.dropdown-item input[type='checkbox'] {
  margin-left: auto;
  cursor: pointer;
}

.dropdown-item input[type='checkbox']:hover {
  background-color: transparent;
}

.bi {
  text-shadow: 0px 0px 2px rgba(205, 205, 205, 0.8);
}

.btn:hover {
  background-color: #e2e2e2;
}

#database:hover {
  color: #323232;
  font-weight: bolder;
}

.coordenadas {
  margin-right: 10px;
}

.justify-content-end {
  display: flex;
  justify-content: right;
}

.unit-icon {
  width: 24px;
  height: 24px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  pointer-events: none;
}

.unit-icon-svg {
  font-size: 24px;
  width: 24px;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
  color: rgb(62, 131, 227);
}

.btn {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  pointer-events: auto;
  min-height: 44px;
  min-width: 44px;
}

.btn:active {
  transform: scale(0.95);
  transition: transform 0.1s;
}

/* Estilo para botones activos */
.btn-active {
  box-shadow: 0 0 10px rgba(40, 167, 69, 0.5);
  border: 1px solid rgb(154, 208, 255);
  position: relative;
}

.btn-active::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  top: -3px;
  right: -3px;
  background-color: rgb(91, 161, 223);
  border-radius: 50%;
  border: 2px solid rgb(154, 208, 255);
  pointer-events: none;
  box-shadow: 0 0 0 1px rgba(40, 167, 69, 0.3);
}

.btn-active:hover {
  background-color: #c9eaba !important;
  border-color: rgb(182, 209, 233) !important;
}

/* Estilo para botón puzzle activo (sin círculo) */
.btn-puzzle-active {
  box-shadow: 0 0 10px rgba(40, 167, 69, 0.5);
  border: 1px solid rgb(154, 208, 255);
  position: relative;
}

.btn-puzzle-active:hover {
  background-color: #c9eaba !important;
  border-color: rgb(182, 209, 233) !important;
}

.menu-footer {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

@media (max-width: 670px) {
  .footer-units .btn {
    padding: 0.2rem 0.1rem;
    margin-right: 0.1rem;
  }

  .footer-units .unit-icon {
    width: 10px;
    height: 10px;
  }

  .unit-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .unit-icon-svg {
    font-size: 20px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .dropdown-menu-small {
    left: 10px !important;
  }
}
</style>
